import accordion from './components/accordion';
import crossSaveToggle from './components/crossSaveToggle';
import confirmDialog from './components/confirmDialog';
import drops from './components/drops';
import entitlements from './components/entitlements';
import inViewport from './components/inViewport';
import itemHistoryModal from './components/itemHistoryModal';
import lazyLoadBackground from './components/lazyLoadBackground';
import reveal from './components/reveal';
import toggleGroupNav from './components/toggleGroupNav';
import toggleNav from './components/toggleNav';
import trackClick from './components/trackClick';
import autosizeAccounts from './components/autosizeAccounts';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

/**
 * Called once the page is loaded and handles initialising
 * the different components.
 */
const init = () => {
  accordion();
  confirmDialog();
  crossSaveToggle();
  drops();
  entitlements();
  inViewport();
  itemHistoryModal();
  lazyLoadBackground();
  reveal();
  toggleGroupNav();
  toggleNav();
  trackClick();
  autosizeAccounts();
};

const canInit = () => {
  const regReady = (window as any).attachEvent ? /d$|^c/ : /d$|^c|^i/;
  return regReady.test(document.readyState || '');
};

let timer: number;

const checkCanInit = () => {
  if (canInit()) {
    if (timer) {
      clearTimeout(timer);
    }

    init();
    return;
  }

  timer = setTimeout(checkCanInit, 100);
};

// update DOM to indicate JavaScript is available
// https://www.paulirish.com/2009/avoiding-the-fouc-v3/
document.documentElement.className = document.documentElement.className.replace(
  /\bno-js\b/,
  'js'
);

checkCanInit();
